import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const BULLETS = [
  "Quality home repairs, installations & remodeling",
  "Honest, transparent pricing on every project",
  "Attention to detail and clean workmanship",
  "Residential, rental & commercial services",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="rs-section bg-white">
      <div className="rs-container">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <p className="rs-overline mb-4">About Us</p>
            <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] leading-tight">
              Craftsmanship, integrity, and{" "}
              <span className="text-[#F97316]">a job done right</span> — the first time.
            </h2>
            <p className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl">
              RS Handyman Services specializes in quality home repairs, installations,
              remodeling, and maintenance. We take pride in honest pricing, excellent
              workmanship, and customer satisfaction. Every project is completed with
              attention to detail and professionalism.
            </p>

            <ul className="mt-8 grid sm:grid-cols-2 gap-4">
              {BULLETS.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <CheckCircle2 className="h-5 w-5 text-[#F97316] flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-wrap gap-4">
              <a href="#services" data-testid="about-services-cta" className="rs-btn-primary">
                Explore Services
              </a>
              <a href="#contact" data-testid="about-quote-cta" className="rs-btn-secondary">
                Request a Quote
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5"
          >
            <div className="relative">
              <div className="absolute -top-6 -left-6 h-40 w-40 rounded-full bg-[#F97316]/10 blur-2xl" />
              <img
                src="https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=1200&q=80"
                alt="High-end interior craftsmanship"
                className="relative rounded-3xl w-full h-[520px] object-cover shadow-2xl"
                loading="lazy"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
